import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const TideIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/Tide.png" style={style} />
}
